import { createContext } from 'react';
import { MenuSize } from './model';

export const MenuContext = createContext<{ size: MenuSize }>({ size: 'normal' });
